import { render } from "./ProjectsNE.vue?vue&type=template&id=c4b006f4&scoped=true"
import script from "./ProjectsNE.vue?vue&type=script&lang=js"
export * from "./ProjectsNE.vue?vue&type=script&lang=js"

import "98.css?vue&type=style&index=0&lang=css"
import "./ProjectsNE.vue?vue&type=style&index=1&id=c4b006f4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/oliverclark15.github.io.source/oliverclark15.github.io.source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4b006f4"]])

export default __exports__